module.exports = __webpack_public_path__ + "static/media/track-collapse.c95d1cfa.svg";